module.exports = __webpack_public_path__ + "static/media/img3-1.dbc2f498.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/banano/biosense/biomasa/img3-1.png
// module id = 1162
// module chunks = 3